﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconForklift } from "@tabler/icons-react";
import { ServiciosDef } from "./ServiciosDef";

export const ServiciosHelpText = "* Aquí tendra la lista de los Servicios disponibles.";
export const ServiciosIcon = IconForklift;
export class Servicios extends Entity<ServiciosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ServiciosDef(), parentKeys);
        super.Form = import('./ServiciosForm').then((module) => module.ServiciosForm);
        this.Title = 'Servicios';
        this.Icon = ServiciosIcon;
        this.HelpText = ServiciosHelpText
    }
}